import { FC } from 'react';
import { Box, HStack, Image, VStack } from '@chakra-ui/react';

import AlarmClock from 'assets/brand/clock.png';
import Text from 'components/_core/Text';
import ReferralCopyButton from 'features/Referral/components/ReferralCopyButton';
import ReferralEmailInviteButton from 'features/Referral/components/ReferralEmailInviteButton/indext';
import ReferralNoCodeCallout from 'features/Referral/components/ReferralNoCodeCallout/ReferralNoCodeCallout';

import locales from '../locales';

interface EmptyReferralsListProps {
  referralCode: string | null;
}

const EmptyReferralsList: FC<EmptyReferralsListProps> = ({ referralCode }) => {
  return (
    <VStack marginTop="space-24">
      <Image
        alt="Alarm clock icon"
        boxSize="80px"
        marginBottom="space-8"
        objectFit="contain"
        src={AlarmClock}
      />
      <Text align="center" marginBottom="space-48">
        {locales.empty}
      </Text>
      {!referralCode ? <ReferralNoCodeCallout /> : null}

      {referralCode ? (
        <HStack gap={32}>
          <Box>
            <ReferralCopyButton promoCode={referralCode} />
          </Box>
          <Box>
            <ReferralEmailInviteButton promoCode={referralCode} />
          </Box>
        </HStack>
      ) : null}
    </VStack>
  );
};

export default EmptyReferralsList;
